import { module } from 'modujs';
import { gsap, MorphSVGPlugin } from '../gsap'

export default class Header extends module {

    static get settings() {

        return {
            ACTIVE_CLASS: 'is-open',
            LIGHT_CLASS: '-light',
            PATH_START: 'M0.24,0.22c0.05-0.02,0.1-0.01,0.15,0c0.06,0.01,0.08,0,0.14,0.01c0.06,0,0.1-0.03,0.16-0.01C0.72,0.23,0.81,0.27,0.82,0.3C0.86,0.39,0.7,0.39,0.67,0.43C0.65,0.45,0.72,0.48,0.74,0.49c0.03,0.03,0.05,0.07,0.04,0.12C0.77,0.66,0.77,0.74,0.73,0.77C0.69,0.8,0.61,0.81,0.57,0.78C0.53,0.75,0.48,0.73,0.44,0.73c-0.05,0-0.1,0.03-0.14,0.05c-0.05,0.03-0.13,0-0.12-0.06C0.18,0.63,0.2,0.55,0.2,0.47C0.21,0.39,0.14,0.26,0.24,0.22z',
            PATH_END: 'M1,0 C1,0.33333 1,0.66667 1,1 0.66667,1 0.33333,1 0,1 0,0.66667 0,0.33333 0,0 0.33333,0 0.66667,0 1,0 z'
        }
    }

    constructor(m) {
        super(m);

        this.$toggler = this.$('toggler')[0]
        this.$bg = this.$('bg')[0]
        this.$morphPath = this.$('path')[0]

        this.events = {
            click: {
                'toggler': 'toggle',
                'close': 'close',
            }
        }
    }


    init() {
        this.isOpen = this.el.classList.contains(Header.settings.ACTIVE_CLASS)
        this.isLight = this.el.classList.contains(Header.settings.LIGHT_CLASS)

        this.currentScroll = window.scrollY

        this.tl = gsap.timeline({
            paused: true,
            defaults: {
                ease: 'circ.inOut',
                duration: 1,
            }
        })

        this.tl
            .fromTo(this.$bg,
                {
                    scale: .5,
                    transformOrigin: '180% -80%'
                },
                {
                    scale: 1,
                },
            0)
            .fromTo(this.$morphPath,
                {
                    scale: 1,
                    morphSVG: {
                        shape: Header.settings.PATH_START,
                        type: 'rotational'
                    },

                },
                {
                    scale: 1.05,
                    morphSVG: {
                        shape: Header.settings.PATH_END,
                        type: 'rotational'
                    },
                },
            0)

        document.addEventListener('keydown', (e) => {

            if(e.code === 'Enter' || e.code === 'Escape') {
                this.close()
            }
        })
    }

    toggle() {

        if(this.isOpen) {
            this.close()
        } else {
            this.open()
        }
    }

    toggleColor(light = false) {
        if(light === this.isLight) {
            return
        }

        if(light) {
            this.el.classList.add(Header.settings.LIGHT_CLASS)
        } else {
            this.el.classList.remove(Header.settings.LIGHT_CLASS)
        }

        this.isLight = light
    }

    open() {

        if(this.isOpen) {
            return
        }

        this.el.classList.add(Header.settings.ACTIVE_CLASS)
        this.isOpen = true

        this.tl.restart()

        // Save page scroll
        this.currentScroll = window.scrollY
        document.body.style.overflowY = 'hidden';
    }

    close() {

        if(!this.isOpen) {
            return
        }

        this.el.classList.remove(Header.settings.ACTIVE_CLASS)
        this.isOpen = false
        this.call('close', null, 'Squish')

        this.tl.reverse()

        // Add previous page scroll
        document.body.style.overflowY = 'scroll';
        window.scrollTo(0, this.currentScroll)
    }
}
